import { gql } from '@apollo/client';

export const UPDATE_LMP_TRACKER_ENABLED = gql`
  mutation($isEnabled: Boolean!) {
    updateLmpTrackerEnabled(isEnabled: $isEnabled) {
      isLmpTrackerEnabled: isLmpTrackerEnabled
    }
  }
`;
